module.exports = require("react-resize-detector");